<template>
  <section
    v-show="diseaseList.length"
    class="disease-type-v2"
    data-stat-id="jb"
    data-stat-expose
  >
    <!--病种Icon-->
    <ul class="disease-type-v2-icons">
      <li
        v-for="(disease, index) in diseaseList"
        :key="`dtn_${index}`"
      >
        <h1 v-if="diseaseList.length > 1">
          {{ disease.insuranceName }}
        </h1>
        <p
          v-for="(item, idx) in disease.list"
          :key="`dtn_i_${idx}`"
          :class="`
            ${disease.list && disease.list.length === 1 ? 'dis-one' : ''}
          `"
          @click="showPop(index, item.id)"
        >
          <i
            :style="`background-position: ${percent * typeIndex[item.type - 1]}% 0`"
          ><!--图标--></i>
          <span>{{ item.title }}</span>
          <em v-if="item.number">{{ item.number }}种</em>
        </p>
        <p />
      </li>
    </ul>
    <p class="more" data-stat-id="jbckxqrk" @click="showPop()">
      查看详情 <bxs-icon name="arrow-right" />
    </p>
    <!--病种详情弹窗-->
    <disease-type-new-pop
      v-if="popStatus"
      ref="diseasePop"
      :default-index="defaultInsuranceIdx"
      :default-category-id="defaultCategoryId"
      :list="diseaseList"
      @close="update({ type: 'close-pop' })"
      @update="update"
    />
  </section>
</template>
<script>
import { Icon } from 'bxs-ui-vue'
import { diseaseListV2 } from 'api/index'
import { getUrlParam } from 'common/js/common'
import DiseaseTypeNewPop from './diseaseTypeNewPop'
export default {
  components: { [Icon.name]: Icon, DiseaseTypeNewPop },
  props: {
    isHost: Boolean,
    isForPresentation: Boolean
  },
  data() {
    return {
      popStatus: false,
      defaultInsuranceIdx: 0,
      defaultCategoryId: 0,
      diseaseList: [],
      percent: 7.7, // icon图片单个icon占比(数量需减一)
      // 险种icon在icon列表中位置：重疾、中症、轻症
      // 险种type对应：1重，2中，3轻
      typeIndex: [12, 11, 10]
    }
  },
  created() {
    diseaseListV2({
      resultUuid: getUrlParam('uuid')
    }).then(res => {
      const list = res.data.data || []
      list.forEach(item => {
        let current = this.diseaseList.find(dis => dis.insuranceId === item.insuranceId)
        const dis = {
          title: item.name,
          id: item.id,
          number: item.diseaseNum,
          type: item.type
        }
        if (!current) {
          current = {
            insuranceName: item.insuranceName,
            insuranceId: item.insuranceId,
            list: [dis]
          }
          this.diseaseList.push(current)
          return
        }
        const last = current.list
        last.push(dis)
        current.list = last.sort((a, b) => a.id - b.id)
      })
    })
  },
  methods: {
    showPop(indIdx, cateIdx) {
      this.preScrollTop = document.body.scrollTop || document.documentElement.scrollTop
      document.body.style.height = window.innerHeight + 'px'
      document.body.style.overflow = 'hidden'
      this.update({
        type: 'show-pop',
        indIdx: indIdx || 0,
        cateIdx: cateIdx || 0
      })
    },
    // 同屏讲解数据同步入口，发送数据和接收数据都从次进入更新视图
    update(data) {
      const { type } = data
      const refs = this.$refs
      const diseasePop = refs.diseasePop
      if (type === 'show-pop' && !this.popStatus) {
        this.defaultInsuranceIdx = isNaN(data.indIdx) ? 0 : data.indIdx
        this.defaultCategoryId = isNaN(data.cateIdx) ? 0 : data.cateIdx
        this.popStatus = true
      } else if (type === 'close-pop') {
        if (this.isHost || !this.isForPresentation) {
          this.popStatus = false
        } else if (diseasePop) {
          // 同屏讲解被控制用户关闭病种弹窗
          diseasePop.close(() => {
            this.popStatus = false
            window.history.go(-1)
          })
        }
        document.body.scrollTop = document.documentElement.scrollTop = this.preScrollTop
        document.body.style.height = 'auto'
        document.body.style.overflow = 'auto'
        this.preScrollTop = 0
      } else if (type === 'tab-change') {
        if (this.isForPresentation && !this.isHost && diseasePop) {
          diseasePop.nav = data.index
        }
      } else if (type === 'sub-tab-change') {
        if (this.isForPresentation && !this.isHost && diseasePop) {
          diseasePop.subNav = data.index
        }
      } else if (type === 'go-search') {
        if (this.isForPresentation && !this.isHost && diseasePop) {
          diseasePop.word = data.word
          diseasePop.Input()
        }
      } else if (type === 'check-disease') {
        if (this.isForPresentation && !this.isHost && diseasePop) {
          diseasePop.$refs.detail.showDisease(data.index, true)
        }
      } else if (type === 'check-desc') {
        if (this.isForPresentation && !this.isHost && diseasePop) {
          diseasePop.$refs.detail.showDesc(data.parentIndex, data.index, true)
        }
      }
      // 发送同步消息，判断是否有控制权，逻辑封装在page-sync-mixin中
      this.syncDelta({
        pbData: { diseaseTypeNew: data }
      })
    }
  }
}
</script>
<style>
@import './diseaseTypeNew.css';
</style>